import React from 'react';
import { FormCourseDataOnly } from './CourseDataInfoBox';

interface CourseDataViewerProps {
  data: FormCourseDataOnly;
}

const CourseDataViewer = ({ data }: CourseDataViewerProps) => {
  return (
    <div className='grid grid-cols-1 md:grid-cols-2'>
      <div>
        <p>Name: {data.name}</p>
        <p>Field: {data.field}</p>
        <p>Description: {data.description}</p>
        <p>Prerequisites: {data.prereqNotes}</p>
        <p>Course Level: {data.courseLevel}</p>
        <p>Recommended Student Count: {data.studentCountInfo?.recommended ?? 'unknown'}</p>
        <p>Max Student Count: {data.studentCountInfo?.recommended ?? 'unknown'}</p>
        <p>
          Grade Range: {data.gradeInfo?.regular.min ?? 'unknown'} -{' '}
          {data.gradeInfo?.regular.max ?? 'unknown'}
        </p>
        <p>
          Exception Grade Range: {data.gradeInfo?.exception.min ?? 'unknown'} -{' '}
          {data.gradeInfo?.exception.max ?? 'unknown'}
        </p>
      </div>
      <div className='ml-0 mt-10 md:ml-1/5 md:mt-0'>
        <p>Sections: </p>
        <div className='ml-8'>
          {data.sections?.map((s, i) => {
            return (
              <div key={i}>
                Section {i + 1}:
                <div className='ml-8'>
                  {s.meetings.map((m, j) => (
                    <div key={j}>
                      <p>Day: {m.day}</p>
                      <p>Time: {m.time} Local Time</p>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CourseDataViewer;
